import { render } from "./cardBox.vue?vue&type=template&id=6d2139d6&scoped=true"
import script from "./cardBox.vue?vue&type=script&lang=js"
export * from "./cardBox.vue?vue&type=script&lang=js"

import "./cardBox.vue?vue&type=style&index=0&id=6d2139d6&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2139d6"]])

export default __exports__